function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { CSSTransition as i } from "react-transition-group";
import { Portal as o } from "./portal.js";
import { TRANSITION_DURATION_MS as a, enter as n, enterActive as s, exit as m, exitActive as c, portal as d, progressContainer as l, progress as p, innerProgress as x } from "./loading-bar.css-mistica.js";
import { getPrefixedDataAttributes as N } from "./utils/dom.js";
const f = (param)=>/* @__PURE__ */ {
    let { visible: r , dataAttributes: t  } = param;
    return e(i, {
        in: r,
        timeout: a,
        classNames: {
            enter: n,
            enterActive: s,
            exit: m,
            exitActive: c
        },
        unmountOnExit: !0,
        children: /* @__PURE__ */ e(o, {
            className: d,
            children: /* @__PURE__ */ e("div", _object_spread_props(_object_spread({
                className: l
            }, N(t, "LoadingBar")), {
                children: /* @__PURE__ */ e("div", {
                    className: p,
                    children: /* @__PURE__ */ e("div", {
                        className: x
                    })
                })
            }))
        })
    });
}, S = f;
export { S as default };
